// WhatWeSupport.js
import React from 'react';
import { motion } from 'framer-motion';
import { UserCheck, Target, Calendar, MessageSquare, FileText, Headphones } from 'lucide-react';

const WhatWeSupport = () => {
  const services = [
    {
      icon: UserCheck,
      title: 'Eligibility and Screening Checks',
      description: 'A close look at what you have done, what you hold, and whether you are ready to work overseas',
      color: 'border-blue-500'
    },
    {
      icon: Target,
      title: 'Matching You to Roles',
      description: 'Pairing your background and availability with positions that genuinely fit',
      color: 'border-green-500'
    },
    {
      icon: Calendar,
      title: 'Arranging Interviews',
      description: 'Booking slots with partner employers once a candidate is ready to be seen',
      color: 'border-purple-500'
    },
    {
      icon: MessageSquare,
      title: 'Preparation and Coaching',
      description: 'Material to work through and one-to-one guidance so you walk in prepared',
      color: 'border-orange-500'
    },
    {
      icon: FileText,
      title: 'Paperwork and Compliance',
      description: 'Help with the documents you need and the compliance rules that apply',
      color: 'border-red-500'
    },
    {
      icon: Headphones,
      title: 'Support That Continues',
      description: 'Someone to guide you for as long as the hiring process runs',
      color: 'border-teal-500'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-semibold text-primary mb-4">
            Where Our Support Applies
          </h2>
          <p className="text-gray-600 text-sm font-light max-w-2xl mx-auto">
            Our work sits in preparation, coordination, and professional readiness
          </p>
        </motion.div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                className={`bg-white border-t-4 ${service.color} p-6 hover:shadow-lg transition-shadow`}
              >
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-surface rounded-lg flex items-center justify-center">
                    <Icon size={24} className="text-primary" />
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-primary mb-2">
                      {service.title}
                    </h3>
                    <p className="text-gray-600 text-sm font-light">
                      {service.description}
                    </p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhatWeSupport;
